/* Do NOT modify this file  - Automatically generated */

window.algoliaShopify = {};
algoliaShopify.config = {
    app_id: "3MUDFZOHW9",
    search_api_key: "9168a5704a0e7f9b42e742e3e498f275",
    index_prefix: "shopify_crb1",
    index_products: true,
    index_collections: true,
    index_articles: false,
    index_pages: false,
    sort_orders: [
        { key: "recently_ordered_count", title: "Popularity", desc: { active: false, title: "Top Sellers" } },
        { key: "published_at", title: "Publication date", desc: { active: true, title: "Newest Items" } },
        { key: "published_at", title: "Publication date", asc: { active: false, title: "Oldest first" } },
        { key: "price", title: "Price", desc: { active: true, title: "Highest Price" } },
        { key: "price", title: "Price", asc: { active: true, title: "Lowest Price" } },
        { key: "title", title: "Name", desc: { active: false, title: "Name Z-A" } },
        { key: "title", title: "Name", asc: { active: false, title: "Name" } },
        { key: "vendor", title: "Vendor", desc: { active: false, title: "Vendor Z-A" } },
        { key: "vendor", title: "Vendor", asc: { active: false, title: "Brand" } },
        { key: "price_ratio", title: "Price ratio", asc: { active: false, title: "Highest discount first" } },
        { key: "inventory_quantity", title: "Inventory quantity", desc: { active: false, title: "Most available" } },
        { key: "grams", title: "Weight", desc: { active: false, title: "Heaviest first" } },
        { key: "grams", title: "Weight", asc: { active: false, title: "Lightest first" } },
    ],
    facets: [
        {
            enabled: false,
            name: "meta.brand.select_brand",
            title: "Select Brand",
            type: "disjunctive",
            available_types: ["menu", "slider", "conjunctive", "disjunctive"],
            forgettable: false,
            searchable: false,
            refined_first: false,
            removeAble: null,
        },
        {
            enabled: true,
            name: "meta.device.select_device",
            title: "Select Device",
            type: "disjunctive",
            available_types: ["menu", "slider", "conjunctive", "disjunctive"],
            forgettable: false,
            searchable: false,
            refined_first: false,
            removeAble: null,
        },
        {
            enabled: true,
            name: "meta.category.select_category",
            title: "Select Product Type",
            type: "disjunctive",
            available_types: ["menu", "slider", "conjunctive", "disjunctive"],
            forgettable: false,
            searchable: false,
            refined_first: false,
            removeAble: null,
        },
        {
            enabled: true,
            name: "meta.battery_type.select_battery_type",
            title: "Select Battery Type",
            type: "disjunctive",
            available_types: ["menu", "slider", "conjunctive", "disjunctive"],
            forgettable: false,
            searchable: false,
            refined_first: false,
            removeAble: null,
        },
        {
            enabled: true,
            name: "options.select_chemistry",
            title: "Select Battery Chemistry",
            type: "disjunctive",
            available_types: ["conjunctive", "disjunctive", "slider"],
            forgettable: true,
            searchable: false,
            refined_first: false,
            removeAble: null,
        },
        {
            enabled: true,
            name: "options.select_capacity",
            title: "Select Battery Capacity",
            type: "disjunctive",
            available_types: ["conjunctive", "disjunctive", "slider"],
            forgettable: true,
            searchable: false,
            refined_first: false,
            removeAble: null,
        },
        {
            enabled: true,
            name: "options.select_case_type",
            title: "Select Battery Case",
            type: "disjunctive",
            available_types: ["conjunctive", "disjunctive", "slider"],
            forgettable: true,
            searchable: false,
            refined_first: false,
            removeAble: null,
        },
        {
            enabled: true,
            name: "meta.charger_type.select_charger_type",
            title: "Select Charger Type",
            type: "disjunctive",
            available_types: ["menu", "slider", "conjunctive", "disjunctive"],
            forgettable: false,
            searchable: false,
            refined_first: false,
            removeAble: null,
        },
        {
            enabled: true,
            name: "meta.charger_design.select_charger_design",
            title: "Select Charger Design",
            type: "disjunctive",
            available_types: ["menu", "slider", "conjunctive", "disjunctive"],
            forgettable: false,
            searchable: false,
            refined_first: false,
            removeAble: null,
        },
        {
            enabled: true,
            name: "meta.charger_use.select_charger_use",
            title: "Select Charger Use",
            type: "disjunctive",
            available_types: ["menu", "slider", "conjunctive", "disjunctive"],
            forgettable: false,
            searchable: false,
            refined_first: false,
            removeAble: null,
        },
        {
            enabled: true,
            name: "meta.charger_technology.select_charger_tech",
            title: "Select Charger Technology",
            type: "disjunctive",
            available_types: ["menu", "slider", "conjunctive", "disjunctive"],
            forgettable: false,
            searchable: false,
            refined_first: false,
            removeAble: null,
        },
        {
            enabled: true,
            name: "options.select_belt_function",
            title: "select belt function",
            type: "disjunctive",
            available_types: ["conjunctive", "disjunctive", "slider"],
            forgettable: true,
            searchable: false,
            refined_first: false,
            removeAble: null,
        },
        {
            enabled: true,
            name: "options.select_material",
            title: "select case material",
            type: "disjunctive",
            available_types: ["conjunctive", "disjunctive", "slider"],
            forgettable: true,
            searchable: false,
            refined_first: false,
            removeAble: null,
        },
        {
            enabled: true,
            name: "options.select_case_height",
            title: "select battery case height",
            type: "disjunctive",
            available_types: ["conjunctive", "disjunctive", "slider"],
            forgettable: true,
            searchable: false,
            refined_first: false,
            removeAble: null,
        },
        { enabled: true, name: "options.select_color", title: "select color", type: "disjunctive", available_types: ["conjunctive", "disjunctive", "slider"], forgettable: true, searchable: false, refined_first: false, removeAble: null },
        { enabled: true, name: "options.select_outlet", title: "select outlet", type: "disjunctive", available_types: ["conjunctive", "disjunctive", "slider"], forgettable: true, searchable: false, refined_first: false, removeAble: null },
        {
            enabled: true,
            name: "options.select_belt_clip",
            title: "select belt clip",
            type: "disjunctive",
            available_types: ["conjunctive", "disjunctive", "slider"],
            forgettable: true,
            searchable: false,
            refined_first: false,
            removeAble: null,
        },
        { enabled: true, name: "options.select_cell", title: "select cell", type: "disjunctive", available_types: ["conjunctive", "disjunctive", "slider"], forgettable: true, searchable: false, refined_first: false, removeAble: null },
        { enabled: true, name: "options.select_case", title: "select case", type: "disjunctive", available_types: ["conjunctive", "disjunctive", "slider"], forgettable: true, searchable: false, refined_first: false, removeAble: null },
        {
            enabled: true,
            name: "options.select_battery_type",
            title: "select battery type",
            type: "disjunctive",
            available_types: ["conjunctive", "disjunctive", "slider"],
            forgettable: true,
            searchable: false,
            refined_first: false,
            removeAble: null,
        },
        {
            enabled: true,
            name: "options.select_cell_brand",
            title: "select cell brand",
            type: "disjunctive",
            available_types: ["conjunctive", "disjunctive", "slider"],
            forgettable: true,
            searchable: false,
            refined_first: false,
            removeAble: null,
        },
        {
            enabled: true,
            name: "options.select_strap_length",
            title: "select strap length",
            type: "disjunctive",
            available_types: ["conjunctive", "disjunctive", "slider"],
            forgettable: true,
            searchable: false,
            refined_first: false,
            removeAble: null,
        },
        { enabled: false, name: "product_type", title: "Type", type: "disjunctive", available_types: ["menu", "conjunctive", "disjunctive"], forgettable: false, searchable: false, refined_first: false, removeAble: null },
        { enabled: false, name: "price", title: "Price", type: "slider", available_types: ["slider"], forgettable: false, searchable: false, refined_first: false, removeAble: null },
        { enabled: false, name: "price_range", title: "Price", type: "disjunctive", available_types: ["disjunctive"], forgettable: false, searchable: false, refined_first: false, removeAble: null },
        { enabled: false, name: "vendor", title: "Select Product Type", type: "disjunctive", available_types: ["menu", "conjunctive", "disjunctive"], forgettable: false, searchable: false, refined_first: false, removeAble: null },
        { enabled: false, name: "tags", title: "Tags", type: "conjunctive", available_types: ["menu", "conjunctive", "disjunctive"], forgettable: false, searchable: false, refined_first: false, removeAble: null },
    ],
    autocomplete_see_all: true,
    colors: { main: "#158EC2", secondary: "#888", muted: "#807EA3", highlight: "#158EC2" },
    autocomplete_enabled: false,
    autocomplete_debug: true,
    input_selector: "form[action='/search']",
    products_autocomplete_hits_per_page: 50,
    collections_autocomplete_hits_per_page: 50,
    articles_autocomplete_hits_per_page: 50,
    pages_autocomplete_hits_per_page: 2,
    instant_search_enabled: true,
    instant_search_enabled_on_collection: true,
    results_selector: "#search",
    products_full_results_hits_per_page: 24,
    collections_full_results_hits_per_page: 20,
    show_products: true,
    analytics_enabled: false,
    usertoken_with_cookies: "disabled",
    collection_id_indexing: true,
    collection_id_query_rules: false,
    collection_search_feature_enabled: true,
    collection_css_selector: ".enable-algolia-jtpl", 
    collection_facets: {
        default: [
            {
                enabled: true,
                name: "meta.brand.select_brand",
                title: "Select Brand",
                type: "disjunctive",
                available_types: ["menu", "slider", "conjunctive", "disjunctive"],
                forgettable: false,
                searchable: false,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: true,
                name: "meta.device.select_device",
                title: "Select Device",
                type: "disjunctive",
                available_types: ["menu", "slider", "conjunctive", "disjunctive"],
                forgettable: false,
                searchable: false,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: true,
                name: "meta.category.select_category",
                title: "Select Product Type",
                type: "disjunctive",
                available_types: ["menu", "slider", "conjunctive", "disjunctive"],
                forgettable: false,
                searchable: false,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: true,
                name: "meta.battery_type.select_battery_type",
                title: "Select Battery Type",
                type: "disjunctive",
                available_types: ["menu", "slider", "conjunctive", "disjunctive"],
                forgettable: false,
                searchable: false,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: true,
                name: "options.select_chemistry",
                title: "Select Battery Chemistry",
                type: "disjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: false,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: true,
                name: "options.select_capacity",
                title: "Select Battery Capacity",
                type: "disjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: false,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: true,
                name: "options.select_case_type",
                title: "Select Battery Case",
                type: "disjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: false,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: true,
                name: "meta.charger_type.select_charger_type",
                title: "Select Charger Type",
                type: "disjunctive",
                available_types: ["menu", "slider", "conjunctive", "disjunctive"],
                forgettable: false,
                searchable: false,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: true,
                name: "meta.charger_design.select_charger_design",
                title: "Select Charger Design",
                type: "disjunctive",
                available_types: ["menu", "slider", "conjunctive", "disjunctive"],
                forgettable: false,
                searchable: false,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: true,
                name: "meta.charger_use.select_charger_use",
                title: "Select Charger Use",
                type: "disjunctive",
                available_types: ["menu", "slider", "conjunctive", "disjunctive"],
                forgettable: false,
                searchable: false,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: true,
                name: "meta.charger_technology.select_charger_tech",
                title: "Select Charger Technology",
                type: "disjunctive",
                available_types: ["menu", "slider", "conjunctive", "disjunctive"],
                forgettable: false,
                searchable: false,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: true,
                name: "options.select_belt_function",
                title: "select belt function",
                type: "disjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: false,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: true,
                name: "options.select_material",
                title: "select case material",
                type: "disjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: false,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: true,
                name: "options.select_case_height",
                title: "select battery case height",
                type: "disjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: false,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: true,
                name: "options.select_color",
                title: "select color",
                type: "disjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: false,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: true,
                name: "options.select_outlet",
                title: "select outlet",
                type: "disjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: false,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: true,
                name: "options.select_belt_clip",
                title: "select belt clip",
                type: "disjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: false,
                refined_first: false,
                removeAble: null,
            },
            { enabled: true, name: "options.select_cell", title: "select cell", type: "disjunctive", available_types: ["conjunctive", "disjunctive", "slider"], forgettable: true, searchable: false, refined_first: false, removeAble: null },
            { enabled: true, name: "options.select_case", title: "select case", type: "disjunctive", available_types: ["conjunctive", "disjunctive", "slider"], forgettable: true, searchable: false, refined_first: false, removeAble: null },
            {
                enabled: true,
                name: "options.select_battery_type",
                title: "select battery type",
                type: "disjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: false,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: true,
                name: "options.select_cell_brand",
                title: "select cell brand",
                type: "disjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: false,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: true,
                name: "options.select_strap_length",
                title: "select strap length",
                type: "disjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: false,
                refined_first: false,
                removeAble: null,
            },
            { enabled: false, name: "product_type", title: "Type", type: "disjunctive", available_types: ["menu", "conjunctive", "disjunctive"], forgettable: false, searchable: false, refined_first: false, removeAble: null },
            { enabled: false, name: "price", title: "Price", type: "slider", available_types: ["slider"], forgettable: false, searchable: false, refined_first: false, removeAble: null },
            { enabled: false, name: "price_range", title: "Price", type: "disjunctive", available_types: ["disjunctive"], forgettable: false, searchable: false, refined_first: false, removeAble: null },
            { enabled: false, name: "vendor", title: "Select Product Type", type: "disjunctive", available_types: ["menu", "conjunctive", "disjunctive"], forgettable: false, searchable: false, refined_first: false, removeAble: null },
            { enabled: false, name: "tags", title: "Tags", type: "conjunctive", available_types: ["menu", "conjunctive", "disjunctive"], forgettable: false, searchable: false, refined_first: false, removeAble: null },
            {
                enabled: false,
                name: "options.select_earbud",
                title: "Select earbud",
                type: "conjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: true,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: false,
                name: "options.select_belt_loop_size",
                title: "Select belt loop size",
                type: "conjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: true,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: false,
                name: "options.select_capcity",
                title: "Select capcity",
                type: "conjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: true,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: false,
                name: "options.select_earpiece",
                title: "Select earpiece",
                type: "conjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: true,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: false,
                name: "options.select_connector_size",
                title: "Select connector size",
                type: "conjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: true,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: false,
                name: "options.select_connector_style",
                title: "Select connector style",
                type: "conjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: true,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: false,
                name: "options.select_output_watt",
                title: "Select output watt",
                type: "conjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: true,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: false,
                name: "options.select_emergency_button",
                title: "Select emergency button",
                type: "conjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: true,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: false,
                name: "options.select_ip_rating_level",
                title: "Select ip rating level",
                type: "conjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: true,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: false,
                name: "options.select_locking_connector",
                title: "Select locking connector",
                type: "conjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: true,
                refined_first: false,
                removeAble: null,
            },
            { enabled: false, name: "options.title", title: "Title", type: "conjunctive", available_types: ["conjunctive", "disjunctive", "slider"], forgettable: true, searchable: true, refined_first: false, removeAble: null },
            {
                enabled: false,
                name: "options.locking_connector",
                title: "Locking connector",
                type: "conjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: true,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: false,
                name: "options.select_smart_battery",
                title: "Select smart battery",
                type: "conjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: true,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: false,
                name: "options.select_voltage",
                title: "Select voltage",
                type: "conjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: true,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: false,
                name: "options.detachable_earpiece",
                title: "Detachable earpiece",
                type: "conjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: true,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: false,
                name: "options.select_connector",
                title: "Select connector",
                type: "conjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: true,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: false,
                name: "options.select_output",
                title: "Select output",
                type: "conjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: true,
                refined_first: false,
                removeAble: null,
            },
            {
                enabled: false,
                name: "options.select_earpiece_style",
                title: "Select earpiece style",
                type: "conjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: true,
                refined_first: false,
                removeAble: null,
            },
            { enabled: false, name: "options.select_volt", title: "Select volt", type: "conjunctive", available_types: ["conjunctive", "disjunctive", "slider"], forgettable: true, searchable: true, refined_first: false, removeAble: null },
            {
                enabled: false,
                name: "options.select_dimension",
                title: "Select dimension",
                type: "conjunctive",
                available_types: ["conjunctive", "disjunctive", "slider"],
                forgettable: true,
                searchable: true,
                refined_first: false,
                removeAble: null,
            },
        ],
    },
    collection_sort_orders: {
        default: [
            { key: "published_at", title: "Publication date", asc: { active: false, title: "Oldest first" } },
            { key: "title", title: "Name", desc: { active: false, title: "Name Z-A" } },
            { key: "title", title: "Name", asc: { active: false, title: "Name" } },
            { key: "vendor", title: "Vendor", desc: { active: false, title: "Vendor Z-A" } },
            { key: "vendor", title: "Vendor", asc: { active: false, title: "Brand" } },
            { key: "price_ratio", title: "Price ratio", asc: { active: false, title: "Highest discount first" } },
            { key: "inventory_quantity", title: "Inventory quantity", desc: { active: false, title: "Most available" } },
            { key: "grams", title: "Weight", desc: { active: false, title: "Heaviest first" } },
            { key: "published_at", title: "Publication date", desc: { active: false, title: "Newest Items" } },
            { key: "price", title: "Price", desc: { active: false, title: "Highest Price" } },
            { key: "price", title: "Price", asc: { active: false, title: "Lowest Price" } },
            { key: "recently_ordered_count", title: "Popularity", desc: { active: false, title: "Top Sellers" } },
            { key: "grams", title: "Weight", asc: { active: false, title: "Lightest first" } },
        ],
    },
    stock_policy: "allow",
    billed_by_shopify: false,
    billing_paused_at: null,
    billing_paused_reason: null,
    autocomplete_query_suggestions: false,
    query_suggestions_index_name: "shopify_crb1products_query_suggestions",
    suggestions_autocomplete_hits_per_page: 2,
    locations_inventory_enabled: false,
    markets_indexing_enabled: false,
    markets_mapping: [],
    markets_available: [],
    markets_webhooks: { product_incremental_sync: "", product_feeds: [] },
    dynamic_selector: false,
    store_currency: "USD",
    restart_index_enabled: false,
    app_block_analytics_disabled: false,
};
